import CharacterItem from "./CharacterItem";

export default CharacterItem;